const predefinedDateFormats = {
	Full:{name:"medium"},
	//Full: {skeleton: 'yyyyMMdd'}, // en-US example: 02/13/2011 (default date format)
	FullYearShort: {skeleton: 'yyMMdd'}, // en-US example: 02/13/11
	LongDate: {date: 'long'}, // en-US example: February 13, 2011
	LongDateWeekDay: 'D', // en-US example: Sunday, February 13, 2011
	YearLong: {skeleton: 'yyyy'}, // 2011
	YearShort: {skeleton: 'yy'}, // 11
	MonthDay: {skeleton: 'MMdd'}, // en-US example: 02 13
	MonthNameDay: {skeleton: 'MMMMd'}, // en-US example: February 13
	MonthShortNameDay: {skeleton: 'MMMd'}, // en-US example: Feb 13
	MonthName: {skeleton: 'MMMM'}, // February
	DayName: {skeleton: 'EEEE'}, // Sunday
	DayOfMonth: {pattern: 'd'}  // 13
};

const predefinedTimeFormats = {
	AmPm: {skeleton: 'hhmm'}, // en-US example:  11:33 PM
	'24H': {skeleton: 'HHmm'}, // en-US example: 23:33 (default time format)
	HourAmPm: {skeleton: 'hh'}, // en-US example: 11 PM
	Hour24H: {skeleton: 'HH'}, // en-US example: 23
	Min: {pattern: 'mm'},  // 33
	Auto: 't' // en-US example: 11:33 PM, Israel example: 23:33

};

const predefinedDateTimeFormats = {
	fullDateTime: {skeleton: 'yyyyMMddHHmm'}, // en-US example: 02/13/2011, 23:33 (default datetime format)
	generalDateTime: {skeleton: 'yyyyMMddHHmmss'}, // en-US example: 02/13/2011, 23:33:44 (general datetime format)
	DateTimeShort: {pattern: 'M.d.yy | H:mm'} // FIXED pattern example: 2.13.11 | 23:33
};

const formatExceptions  = {
	"he-IL": {
		LongDate: {pattern: 'MMMM dd, yyyy'},
		MonthDay: {pattern: 'dd.MM'},
		MonthNameDay: {pattern: 'MMMM d'},
		Full:{pattern: 'dd/MM/yyyy'},
		fullDateTime:{skeleton: 'dd/MM/yyyyHHmm'},
		generalDateTime:{skeleton: 'dd/MM/yyyyHHmmss'},
	},
};

export const getPredefinedFormats = (localeId) => {
	const localeExceptions = formatExceptions[localeId];
	return {...predefinedDateTimeFormats,...predefinedDateFormats, ...predefinedTimeFormats, ...localeExceptions};
};

